import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * Borrowed from {@link https://github.com/angular/angular/blob/72c7b6edea39f6591463c2a22eb24d087fd756b7/packages/common/http/src/module.ts @angular/common/http}
 *
 * Applies an `HttpInterceptor` to an `HttpRequest`.
 */
@Injectable({ providedIn: 'root' })
export class HttpInterceptorHandler implements HttpHandler {
    constructor(private next: HttpHandler, private interceptor: HttpInterceptor) {}

    public handle(req: HttpRequest<any>): Observable<HttpEvent<any>> {
        return this.interceptor.intercept(req, this.next);
    }
}
